import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';

// Hooks
import { useStores } from 'hooks/use-stores';
import { getLastLocationFromLocalStorage } from 'utils/History';

const Logout = () => {
  const [loggedOut, setLoggedOut] = useState(false);
  const { userStore } = useStores();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async () => {
      try {
        await userStore.logout();
        setLoggedOut(true);
      } catch (error) {
        console.error(error);
        setLoggedOut(true);
      }
    })();
  }, [userStore]);

  return loggedOut ? <Redirect to={getLastLocationFromLocalStorage()} /> : <span>Logging you out...</span>;
};

export default observer(Logout);
